import ROLES from "../../roles";

export default {
  /**
   * @path http://localhost:8081/#/bulldings
   * Prevent user from adding/view/modifying/updating buildings
   */
  CAN_ADD_COMPLEX: [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.TOW_COMPANY,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.TOW_COMPANY_SALES_REP,
  ], // who can add a complex
  CAN_NOT_DELETE_PERMITS: [
    ROLES.SALES,
    ROLES.MANAGER,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.LEASING_STAFF,
    ROLES.TOW_DRIVER,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.PB_FIELD_AGENT,
    ROLES.TOW_COMPANY_SALES_REP,
    ROLES.TENANT,
  ],
  CAN_NOT_DELETE_RESIDENT_PERMITS: [
    ROLES.SALES,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.TOW_DRIVER,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.PB_FIELD_AGENT,
    ROLES.TOW_COMPANY_SALES_REP,
    ROLES.TENANT,
  ],
  CAN_NOT_DELETE_DO_NOT_TOW_PERMITS: [
    ROLES.SALES,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.LEASING_STAFF,
    ROLES.TOW_DRIVER,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.PB_FIELD_AGENT,
    ROLES.TOW_COMPANY_SALES_REP,
    ROLES.TENANT,
  ], // users that can NOT delete permits
  CAN_NOT_DELETE_BLOCKED_PERMITS: [this.CAN_NOT_DELETE_DO_NOT_TOW_PERMITS],
  CAN_NOT_DELETE_RESERVED_PERMITS: [
    ROLES.SALES,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.TOW_DRIVER,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.PB_FIELD_AGENT,
    ROLES.TOW_COMPANY_SALES_REP,
    ROLES.TENANT,
  ],
  CAN_NOT_ARCHIVE_PERMITS: [ROLES.CLIENT_SERVICE_REP],
  CAN_DELETE_APARTMENT: [ROLES.ADMIN],
  CAN_DELETE_APARTMENT_COUPONS: [ROLES.ADMIN, ROLES.TOW_COMPANY],
  CAN_DELETE_APARTMENT_EVENTS: [ROLES.ADMIN],
  CAN_NOT_VIEW_DETAILS_PAYMENTS_ACCOUNTS: [ROLES.TOW_DRIVER],
  CAN_NOT_VIEW_PROPERTY_PERCENTAGE: [
    ROLES.CLIENT_SERVICE_REP,
    ROLES.LEASING_STAFF,
    ROLES.PB_SUPPORT_STAFF,
  ],
  CAN_NOT_VIEW_PROPERTY_SALES_PERCENTAGE: [ROLES.TOW_COMPANY, ROLES.MANAGER],
  CAN_NOT_ACCESS_ACCOUNT_PERMIT_MENU: [ROLES.TOW_DRIVER],
  NOT_ACCESS_ACCOUNT_PAYMENTS_PERMIT_MENU: [
    ROLES.TOW_DRIVER,
    ROLES.LEASING_STAFF,
  ], // users that can NOT view apartment details percentage & sales percentage
  CAN_NOT_VIEW_PROPERTY_COMMISSION_FEE: [ROLES.CLIENT_SERVICE_REP], // users that can NOT view apartment details guest fee (commission)
  CAN_SET_APARTMENT_MANAGER_RULES: [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.PB_SUPPORT_STAFF,
    ROLES.TOW_COMPANY,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.TOW_COMPANY_SALES_REP,
  ], // users that can toggle managers rules in apartment details
  CAN_SET_APARTMENT_MANAGER_ADDENDUM: [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.TOW_COMPANY_SALES_REP,
    ROLES.TOW_COMPANY,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.PB_SUPPORT_STAFF,
  ], // users that can toggle managers addendum in apartment details
  RESIDENT_ACCOUNT_APT_DETAILS: [ROLES.TENANT], // can view only apartment details name, address
  CAN_REFUND_PAYMENTS: [ROLES.ADMIN, ROLES.PB_SUPPORT_STAFF], // can view refund on payments
  CAN_NOT_PRINT_PERMITS: [ROLES.TOW_DRIVER, ROLES.PB_FIELD_AGENT], // can NOT download reserved permits
  CAN_NOT_SEE_PERMITS_RESIDENT_NAME_UNIT: [], // can NOT see permits resident name, unit number
  CAN_NOT_EDIT_APT_DETAILS: [ROLES.LEASING_STAFF], // can NOT edit apartment details
  CAN_ADD_RESIDENT_PERMIT: [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.MANAGER,
    ROLES.TOW_COMPANY,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.LEASING_STAFF,
  ], // Can add resident permits
  CAN_ADD_RESERVED_PERMIT: [
    ROLES.ADMIN,
    ROLES.SALES,
    ROLES.MANAGER,
    ROLES.TOW_COMPANY,
    ROLES.CLIENT_SERVICE_REP,
    ROLES.LEASING_STAFF,
  ], // Can add resident permits
  CAN_CHECKIN: [ROLES.TOW_DRIVER],
  CAN_EDIT_ENFORCEMENT_RULES: [ROLES.MANAGER, ROLES.ADMIN, ROLES.TOW_COMPANY],
  CAN_EDIT_SCHEDULE: [ROLES.MANAGER, ROLES.ADMIN, ROLES.TOW_COMPANY],
  CAN_VIEW_BLOCKED_PERMITS_NOTES: [ROLES.MANAGER, ROLES.LEASING_STAFF],
  CAN_NOT_EDIT_PARKING_RULES: [ROLES.LEASING_STAFF],
  CAN_EDIT_GUEST_PERMIT: [ROLES.ADMIN],
  CAN_NOT_EDIT_SPECIFIC_FIELDS_PROP_DETAILS: [ROLES.MANAGER],
  CAN_ENTER_TENANT_REGISTRATION_ROUTE: [ROLES.ADMIN, ROLES.MANAGER],
};



// WEBPACK FOOTER //
// ./src/roles/rules/buildings/index.js